import {Injectable} from '@angular/core';
import {Config} from "../../config";

@Injectable()
export class RestAngularConfig {
  static RestangularProvider;
  static RestangularConfigFactory (RestangularProvider, ErrorHandler) {
     RestAngularConfig.RestangularProvider = RestangularProvider;
     RestangularProvider.setBaseUrl(Config.BASE_URL);
     // RestAngularConfig.errorHandling();
  }
  private static errorHandling() {
    RestAngularConfig.RestangularProvider.addErrorInterceptor((response, subject, responseHandler) => {
      if (response.status >= 400) {
        console.error(response.statusText);
        return false; // error handled
      }
      return true; // error not handled
    });
  }
}



// WEBPACK FOOTER //
// /var/www/apps/asna/front-end/public_html/src/app/service/restAngular/rest-angular-config.ts